// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"450f9074","301":"599232f5","313":"f7f60236"}[chunkId] + ".chunk.js";
};